import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'

import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import JobStatusChanger from '../../Components/JobStatusChanger'
import Select from 'react-select'
import Datetime from 'react-datetime'
import StatusCell from '../../List/Components/StatusCell'

import useViewModel from './ViewModel'
import clsx from 'clsx'
// import moment from 'moment'
import { findReactSelectOption } from 'Utils/findReactSelectOption'

const IssueRequestChangePileSize: React.FC = () => {
  const {
    cancel,
    disabledSubmitButton,
    findedSaleOrder,
    originalJobStatus,
    formik,
    isCreate,
    isView,
    saleOrder,
    openJobStatusChanger,
    onChangeJobStatus,
    handleOpenJobStatusChanger,
    handleCloseJobStatusChanger,
    onSubmitStatus,
  } = useViewModel()

  return (
    <ViewPageTitle isCreate={isCreate} isView={isView}>
      <JobStatusChanger
        open={openJobStatusChanger}
        value={formik.values.jobStatus}
        onChange={onChangeJobStatus}
        handleClose={handleCloseJobStatusChanger}
        handleSubmit={onSubmitStatus}
      />

      <div className='row gy-5 mb-5'>
        <div className='col-12'>
          <PageBreadCrumb />
        </div>

        <div className='col-12'>
          <div className='card'>
            <div className='card-footer'>
              <div className='d-flex justify-content-between align-items-center'>
                <div>
                  สถานะงาน: <StatusCell status={originalJobStatus} />
                </div>
                <div className='text-end'>
                  {!isCreate && !isView && (
                    <button
                      type='button'
                      className='btn btn-sm btn-primary fw-bold me-4'
                      onClick={handleOpenJobStatusChanger}>
                      แก้ไขสถานะงาน
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-12'>
          <form
            onSubmit={(e: any) => {
              e.preventDefault()
              formik.handleSubmit(e)
            }}>
            <div className='card'>
              <div className='card-body'>
                <div className='row gy-3'>
                  {/* Sale Order */}
                  <div className='col-12 col-xl-3'>
                    <label className='mb-2'>
                      Sale Order ID. <span className='required' />
                    </label>

                    <Select
                      name='saleOrderId'
                      isSearchable={true}
                      styles={{
                        control: (provided: any) => ({
                          ...provided,
                          borderColor:
                            formik.touched.saleOrderId && formik.errors.saleOrderId
                              ? 'red'
                              : '#e1e3ea',
                        }),
                      }}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      options={saleOrder}
                      onBlur={() => formik.setFieldTouched('saleOrderId')}
                      onChange={(selectedOption: any) => {
                        if (selectedOption)
                          formik.setFieldValue('saleOrderId', selectedOption.value)
                      }}
                      value={findReactSelectOption({
                        value: formik.getFieldProps('saleOrderId').value,
                        options: saleOrder,
                      })}
                    />

                    {formik.touched.saleOrderId && formik.errors.saleOrderId && (
                      <div className='fv-plugins-message-container mt-2'>
                        <div className='fv-help-block'>{formik.errors.saleOrderId}</div>
                      </div>
                    )}
                  </div>

                  {/* Division */}
                  <div className='col-12 col-xl-3'>
                    <label className='mb-2'>
                      ชื่อหน่วยงาน <span className='required' />
                    </label>
                    <input
                      type='text'
                      disabled
                      className={clsx('form-control form-control-sm', {
                        'is-invalid': formik.touched.saleOrderId && formik.errors.saleOrderId,
                      })}
                      value={findedSaleOrder?.division ?? ''}
                      onChange={(e: any) => {}}
                    />

                    {formik.touched.saleOrderId && formik.errors.saleOrderId && (
                      <div className='fv-plugins-message-container mt-2'>
                        <div className='fv-help-block'>{formik.errors.saleOrderId}</div>
                      </div>
                    )}
                  </div>

                  {/* Requested At */}
                  <div className='col-12 col-xl-3'>
                    <label className='mb-2'>
                      วันที่แจ้ง <span className='required' />
                    </label>
                    <Datetime
                      locale='en'
                      dateFormat='DD/MM/YYYY'
                      timeFormat={false}
                      renderInput={props => {
                        return (
                          <input
                            {...props}
                            autoComplete='off'
                            className={clsx(props.className, {
                              'is-invalid': formik.touched.requestedAt && formik.errors.requestedAt,
                            })}
                          />
                        )
                      }}
                      closeOnClickOutside
                      className='filter-date-input w-100 z-4'
                      value={formik.values.requestedAt}
                      onChange={(val: any) => formik.setFieldValue('requestedAt', val)}
                    />

                    {formik.touched.requestedAt && formik.errors.requestedAt && (
                      <div className='fv-plugins-message-container mt-2'>
                        {/* @ts-ignore */}
                        <div className='fv-help-block'>{formik.errors.requestedAt}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-12 col-xl-3'>
                    ผู้ขอ <span className='required'></span>
                    <span className='align-items-center d-flex flex-row mt-2'>
                      <div className='position-relative w-100'>
                        <input
                          type='text'
                          className={clsx('form-control form-control-sm', {
                            'is-invalid': formik.touched.requester && formik.errors.requester,
                          })}
                          {...formik.getFieldProps('requester')}
                        />
                        <div
                          className='position-absolute text-gray-500'
                          style={{ top: '22%', right: 10 }}>
                          {/* (แผ่น) */}
                        </div>
                      </div>
                    </span>
                    {formik.touched.requester && formik.errors.requester && (
                      <div className='fv-plugins-message-container mt-2'>
                        <div className='fv-help-block'>{formik.errors.requester}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-12 mt-10 mb-5'>
                    <span className='fw-bold fs-4'>รายละเอียดของเสา</span>
                  </div>

                  {/* <div className='col-12 col-xl-4'>
                    <label className='mb-2'>
                      วันที่ <span className='required' />
                    </label>
                    <Datetime
                      locale='en'
                      dateFormat='DD/MM/YYYY'
                      timeFormat={false}
                      renderInput={props => {
                        return (
                          <input
                            {...props}
                            autoComplete='off'
                            className={clsx(props.className, {
                              'is-invalid': formik.touched.requireDate && formik.errors.requireDate,
                            })}
                          />
                        )
                      }}
                      closeOnClickOutside
                      className='filter-date-input w-100 z-4'
                      value={formik.values.requireDate}
                      onChange={(val :any) => {
                        // combine new date with old time
                        const time = moment(formik.values.requireDate).format('HH:mm')
                        const date = moment(val).format('YYYY-MM-DD')
                        formik.setFieldValue('requireDate', moment(`${date} ${time}`))
                      }}
                    /> */}

                  {/* {formik.touched.requestedAt && formik.errors.requestedAt && (
                      <div className='fv-plugins-message-container mt-2'> */}
                  {/* @ts-ignore */}
                  {/* <div className='fv-help-block'>{formik.errors.requestedAt}</div>
                      </div>
                    )}
                  </div> */}

                  {/* <div className='col-12 col-xl-4'>
                    <label className='mb-2'>
                      เวลา (สามารถนำแผ่นเหล็กเข้าได้) <span className='required' />
                    </label>
                    <Datetime
                      locale='en'
                      dateFormat={false}
                      timeFormat='HH:mm'
                      renderInput={props => {
                        return (
                          <input
                            {...props}
                            autoComplete='off'
                            className={clsx(props.className, {
                              'is-invalid': formik.touched.requireDate && formik.errors.requireDate,
                            })}
                          />
                        )
                      }}
                      closeOnClickOutside
                      className='filter-date-input w-100 z-4'
                      value={formik.values.requireDate}
                      onChange={(val :any) => {
                        // combine new time with old date
                        const time = moment(val).format('HH:mm')
                        const date = moment(formik.values.requireDate).format('YYYY-MM-DD')

                        formik.setFieldValue('requireDate', moment(`${date} ${time}`))
                      }}
                    />

                    {formik.touched.requireDate && formik.errors.requireDate && (
                      <div className='fv-plugins-message-container mt-2'> */}
                  {/* @ts-ignore */}
                  {/* <div className='fv-help-block'>{formik.errors.requireDate}</div>
                      </div>
                    )}
                  </div> */}

                  <div className='col-12 col-xl-4'>
                    จำนวนเสาที่ต้องการ <span className='required'></span>
                    <span className='align-items-center d-flex flex-row mt-2'>
                      <div className='position-relative w-100'>
                        <input
                          type='text'
                          className={clsx('form-control form-control-sm', {
                            'is-invalid': formik.touched.quantity && formik.errors.quantity,
                          })}
                          {...formik.getFieldProps('quantity')}
                        />
                        <div
                          className='position-absolute text-gray-500'
                          style={{ top: '22%', right: 10 }}>
                          {/* (แผ่น) */}
                        </div>
                      </div>
                    </span>
                    {formik.touched.quantity && formik.errors.quantity && (
                      <div className='fv-plugins-message-container mt-2'>
                        <div className='fv-help-block'>{formik.errors.quantity}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-12 col-xl-4'>
                    ขนาดเดิมของเสา <span className='required'></span>
                    <span className='align-items-center d-flex flex-row mt-2'>
                      <div className='position-relative w-100'>
                        <input
                          type='text'
                          className={clsx('form-control form-control-sm', {
                            'is-invalid': formik.touched.oldSize && formik.errors.oldSize,
                          })}
                          {...formik.getFieldProps('oldSize')}
                        />
                        <div
                          className='position-absolute text-gray-500'
                          style={{ top: '22%', right: 10 }}>
                          {/* (แผ่น) */}
                        </div>
                      </div>
                    </span>
                    {formik.touched.oldSize && formik.errors.oldSize && (
                      <div className='fv-plugins-message-container mt-2'>
                        <div className='fv-help-block'>{formik.errors.oldSize}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-12 col-xl-4'>
                    ขนาดใหม่ของเสา <span className='required'></span>
                    <span className='align-items-center d-flex flex-row mt-2'>
                      <div className='position-relative w-100'>
                        <input
                          type='text'
                          className={clsx('form-control form-control-sm', {
                            'is-invalid': formik.touched.newSize && formik.errors.newSize,
                          })}
                          {...formik.getFieldProps('newSize')}
                        />
                        <div
                          className='position-absolute text-gray-500'
                          style={{ top: '22%', right: 10 }}>
                          {/* (แผ่น) */}
                        </div>
                      </div>
                    </span>
                    {formik.touched.newSize && formik.errors.newSize && (
                      <div className='fv-plugins-message-container mt-2'>
                        <div className='fv-help-block'>{formik.errors.newSize}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-12'>
                    <label className='mb-2'>คำขอเพิ่มเติม</label>
                    <textarea
                      className='form-control form-control-sm'
                      rows={5}
                      {...formik.getFieldProps('remark')}
                    />
                    {formik.touched.remark && formik.errors.remark && (
                      <div className='fv-plugins-message-container mt-2'>
                        <div className='fv-help-block'>{formik.errors.remark}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {!isView && (
                <div className='card-footer text-center text-lg-end'>
                  <button
                    className='btn btn-sm btn-secondary fw-bold me-4 w-sm-100 mb-5 mb-xl-0'
                    type='button'
                    onClick={() => cancel()}>
                    ยกเลิก
                  </button>
                  <button
                    className='btn btn-sm btn-primary fw-bold w-sm-100'
                    type='submit'
                    disabled={disabledSubmitButton}>
                    บันทึก
                  </button>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren & { isCreate: boolean; isView: boolean }> = ({
  children,
  isCreate,
  isView,
}) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: true,
            isSeparator: false,
            path: '/request',
            title: 'รายการทั้งหมด',
            icon: '/media/icons/duotune/files/fil005.svg',
          },
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: isView ? 'รายละเอียดการขอ' : isCreate ? 'เพิ่ม' : 'แก้ไข',
          },
        ]}>
        {isView
          ? 'รายละเอียดการขอเปลี่ยนแปลงเสา'
          : isCreate
          ? 'สร้างรายการขอเปลี่ยนแปลงเสา'
          : 'แก้ไขรายการขอเปลี่ยนแปลงเสา'}
      </PageTitle>

      {children}
    </>
  )
}

export default IssueRequestChangePileSize
